
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[section]/[...contentPath]",
      function () {
        return require("private-next-pages/[section]/[...contentPath].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[section]/[...contentPath]"])
      });
    }
  